// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { IAssetPreviewProps } from "./assetPreview";
import { loadImageToCanvas } from "../../../../common/utils";
import { constants } from "../../../../common/constants";
import axios from "axios";

interface IImageAssetState {
    imageUri: string;
    imgSrc: string;
}

interface IImageAssetProps {
    src?: string;
}

/**
 * ImageAsset component used to render all image assets
 */
export class ImageAsset extends React.Component<IImageAssetProps, IImageAssetState> {
    private image: React.RefObject<HTMLImageElement> = React.createRef();

    constructor(props: IImageAssetProps) {
        super(props);

        this.state = {
            imageUri: null,
            imgSrc: null
        };
    }

    public async componentDidMount() {
        // if (this.props.asset != null) {
        //     const canvas = await loadImageToCanvas(this.props.asset.path);
        //     this.setState({
        //         imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedThumbnailQuality),
        //     });
        // }

        // axios.get(this.props.src, {
        //     responseType: "blob" // IMPORTANT
        // })
        // .then(res => {
        //     const url = URL.createObjectURL(res.data);
        //     this.setState({ imgSrc: url });
        // })
        // .catch(err => console.error(err));

        axios.get(this.props.src, {
            responseType: "blob"
        })
        .then(res => {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({ imgSrc: reader.result as string });
            };
            reader.readAsDataURL(res.data);
        })
        .catch(err => console.error(err));
    }

    public render() {
        return (
            <img ref={this.image}
                src={this.state.imgSrc}
                // alt={this.props.asset.name}
                // onLoad={this.onLoad}
                // onError={(e) => {
                //     this.props.onError(e);
                // }}
                crossOrigin="anonymous" 
                width="150" 
                height="150"
                />);
    }

    // private onLoad = () => {
    //     if (this.props.onLoaded) {
    //         this.props.onLoaded(this.props.asset, this.image.current);
    //     }
    //     if (this.props.onActivated) {
    //         this.props.onActivated(this.image.current);
    //     }
    //     if (this.props.onDeactivated) {
    //         this.props.onDeactivated(this.image.current);
    //     }
    // }
}
